import React, { Component } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { get } from 'lodash';
import cns from 'classnames';
import PropTypes from 'prop-types';
import { RuntimeContext } from '../../../common/RuntimeContext';
import VerbSelect from '../../shared/components/formComponents/inputs/VerbSelect';
import VerbButton, { VERB_BUTTON_TYPE } from '../../shared/components/VerbButton';

class CopyAssetLink extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedOption: '',
            copied: false
        };
    }

    static propTypes = {
        assetLinkOptions: PropTypes.array
    };

    static contextType = RuntimeContext;

    componentWillUnmount() {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
        }
    }

    handleChange = (selectedOption) => {
        this.setState({ selectedOption });
    };

    onCopy = () => {
        this.setState({ copied: true });
        this.timeoutId = setTimeout(() => {
            this.setState({ copied: false });
        }, 3000);
    };

    render() {
        const { selectedOption } = this.state;
        const copiedText = `${this.context.pathsWeb.clientUrl}/assetlink/${get(selectedOption, 'value', '')}`;
        return (
            <div className={'copy-asset-link'}>
                <h6>Generate Link to Learning Asset</h6>
                <div className={'row'}>
                    <div className={'col-9'}>
                        <VerbSelect
                            value={selectedOption}
                            onChange={this.handleChange}
                            options={this.props.assetLinkOptions}
                        />
                    </div>
                    <div className={'col-lg-3 col-md-3 copy-asset-link-button'}>
                        <CopyToClipboard onCopy={this.onCopy} text={copiedText}>
                            <VerbButton buttonType={VERB_BUTTON_TYPE.SECONDARY_DEFAULT}>Copy URL</VerbButton>
                        </CopyToClipboard>
                    </div>
                    <span
                        className={cns('copy-asset-link-feedback col-lg-12 col-md-12', {
                            invisible: !this.state.copied
                        })}
                    >
                        <p>{`Copied ${copiedText}`}</p>
                    </span>
                </div>
            </div>
        );
    }
}

export default CopyAssetLink;
